import playerComp1 from "../img/player-comps/player-comp@1x.png";
import playerComp1x2 from "../img/player-comps/player-comp@2x.png";

export interface IPlayerCompProps {
  images: Record<string, string>;
}

let choice = -1;

export const getPlayerComp = () => {
  const playerImages = [
    {
      x1: playerComp1,
      x2: playerComp1x2,
    },
    {
      x1: playerComp1,
      x2: playerComp1x2,
    },
    {
      x1: playerComp1,
      x2: playerComp1x2,
    },
    {
      x1: playerComp1,
      x2: playerComp1x2,
    },
    {
      x1: playerComp1,
      x2: playerComp1x2,
    },
    {
      x1: playerComp1,
      x2: playerComp1x2,
    },
  ];

  if (choice < 0) {
    choice = Math.floor(Math.random() * playerImages.length);
  }
  return playerImages[choice];
};
